import { render, staticRenderFns } from "./NotificacionesAdmin.vue?vue&type=template&id=02d7fbe2&"
import script from "./NotificacionesAdmin.vue?vue&type=script&lang=js&"
export * from "./NotificacionesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports